<div class="layout-container" [ngClass]="[
  'min-h-screen',
  'layout-' + layoutService.sidebarMode(),
  layoutService?.sidebarActive() ? 'sidebar-active' : 'sidebar-inactive',
]">
  <div [ngClass]="[
    '@container/topbar layout-topbar fixed top-0 left-0 w-screen z-[1000] h-14 bg-[#FBF9F9] dark:bg-neutral-900 border-b border-[#F6EFEE] dark:border-neutral-800',
    layoutService.sidebarMode() === 'mobile' ? 'layout-mobile' : 'layout-desktop'
  ]">
    <div class="mx-auto w-full max-w-7xl px-6 h-full flex items-center">
      @if (layoutService.sidebarMode() === 'desktop') {
        <span class="text-sm text-gray-500">v{{ version }}</span>
      }
      <div class="topbar-left hidden md:flex md:w-56 min-w-[180px] items-center gap-2 h-full py-2 border-r border-[#EEE8EC] dark:border-neutral-800">
        @if(layoutService.sidebarMode() === 'desktop') {
          <a class="app-logo h-full hidden md:block" [routerLink]="['/']">
            <img
              loading="lazy"
              alt="NorthAI Logo"
              [src]="layoutService.topbarLogoPath()"
              class="h-full app-logo w-full px-4"
            >
          </a>
        }
      </div>

      <div class="topbar-center flex items-center gap-2 px-8 w-[60%] sm:w-[70%] md:w-full">
        <div class="topbar-center-middle flex flex-col w-full">
          <div class="topbar-center-middle-bottom flex flex-row items-center gap-2 h-8 w-full">
             <!-- <app-breadcrumb></app-breadcrumb> -->
             <button
             type="button"
             (click)="openOrganizationDialog()"
             class="flex items-center gap-2 cursor-pointer px-3 py-2 border border-[rgba(249,112,2,0.6)] dark:border-orange-500/60 rounded-lg bg-white dark:bg-neutral-800 transition-colors h-10 hover:opacity-90 max-w-[16rem]"
           >
             @if (sessionService.activeOrganization(); as org) {
               <app-identicon [seed]="org.id" class="h-5 w-5 rounded-sm shrink-0" />
               <span class="text-sm font-medium text-[#F97002] dark:text-orange-400 truncate">{{ org.name }}</span>
             } @else {
               <i class="pi pi-building text-[#F97002] dark:text-orange-400"></i>
               <span class="text-sm font-medium text-[#F97002] dark:text-orange-400">Select Org</span>
             }
             <i class="pi pi-chevron-down text-xs text-[#F97002] dark:text-orange-400"></i>
           </button>
          </div>
        </div>
      </div>


      <div class="topbar-right flex items-center gap-2" style="z-index: 200000">

        <!-- <a
          href="https://legacy.app.northai.io"
          title="Looking for the old version? Go here"
          aria-label="Looking for the old version? Go here"
          class="inline-flex items-center gap-2 h-10 px-3 rounded-lg border border-[rgba(249,112,2,0.6)] dark:border-orange-500/60 bg-white dark:bg-neutral-800 text-[#F97002] dark:text-orange-400 text-sm font-medium hover:opacity-90 transition-opacity whitespace-nowrap"
        >
          <i class="pi pi-history"></i>
          <span class="hidden lg:inline">Old version</span>
        </a> -->

        @if(!layoutService.isMobile() && showCreditMeter()) {
          <p-button
            [label]="(usageService.availableCredits() | number:0) || '0'"
            iconPos="left"
            icon="pi pi-wallet"
            (click)="usagePop.toggle($event)"
            styleClass="!bg-[#F97002] !border-[#F97002] !text-white hover:!bg-[#d45f00] !rounded-lg !px-4 !py-2 !font-medium"
          >
          </p-button>
          <p-popover #usagePop>
            <div class="w-full">
              <app-credit-meter></app-credit-meter>
            </div>
          </p-popover>
        }
        @if(inboxService.numUnread() > 0) {
          <p-overlaybadge [badgeDisabled]="inboxService.numUnread() === 0" [value]="inboxService.numUnread()">
            <p-button
              icon="pi pi-bell"
              (click)="inboxDrawerVisible.set(true)"
              styleClass="!w-10 !h-10 !border !border-[rgba(249,112,2,0.6)] dark:!border-orange-500/60 !bg-white dark:!bg-neutral-800 !text-[#F97002] dark:!text-orange-400"
            ></p-button>
          </p-overlaybadge>
        } @else {
          <p-button
            icon="pi pi-bell"
            (click)="inboxDrawerVisible.set(true)"
            styleClass="!w-10 !h-10 !border !border-[rgba(249,112,2,0.6)] dark:!border-orange-500/60 !bg-white dark:!bg-neutral-800 !text-[#F97002] dark:!text-orange-400"
          ></p-button>
        }
        <p-button
          [icon]="layoutService.isDarkMode() ? 'pi pi-sun' : 'pi pi-moon'"
          (click)="layoutService.toggleDarkMode()"
          styleClass="!w-10 !h-10 !border !border-[rgba(249,112,2,0.6)] dark:!border-orange-500/60 !bg-white dark:!bg-neutral-800 !text-[#F97002] dark:!text-orange-400"
        ></p-button>

        <p-menu #userMenu [model]="userMenuItems" [popup]="true" appendTo="body" />
        <button
          type="button"
          (click)="userMenu.toggle($event)"
          class="flex items-center gap-2 cursor-pointer px-4 py-2 border border-[rgba(249,112,2,0.6)] dark:border-orange-500/60 rounded-lg bg-white dark:bg-neutral-800 transition-colors h-10 hover:opacity-90"
        >
          <span class="text-base font-medium text-[#F97002] dark:text-orange-400 whitespace-nowrap">{{ sessionService.profile()?.display_name || 'User' }}</span>
        </button>
      </div>
    </div>
  </div>
  <!--
    GLOBAL SIDEBAR (TEMP DISABLED)
    We previously rendered a single app-wide sidebar here. We're moving to contextual, page-owned sidebars,
    so this block is intentionally commented out (not deleted) and can be re-enabled / moved later.
  -->
  <!-- <div
    [ngClass]="{
      'layout-sidebar fixed w-56 flex flex-col h-calc(100vh - 5rem) left-0 top-[5rem] z-[999]': true,
      'layout-desktop': layoutService.sidebarMode() === 'desktop',
      'layout-mobile': layoutService.sidebarMode() === 'mobile'
    }"
  >
    <div #menuContainer class="sidebar-menu-container" [ngClass]="[
      'layout-menu-container overflow-auto pl-2 pr-2',
      layoutService.sidebarMode()
    ]">
      <app-base-sidebar></app-base-sidebar>
    </div>
  </div> -->
  <div class="layout-content-wrapper pt-14">
    <div (scroll)="onWindowScroll($event)" [ngClass]="[
      'layout-content',
      layoutService?.sidebarMode() === 'mobile' ? 'layout-mobile' : 'layout-desktop',
      layoutService.isDarkMode() ? 'dark' : ''
    ]">
      <div [ngClass]="['layout-content-inner', 'layout-' + layoutService?.screenSize()]">
        <router-outlet></router-outlet>
        <!-- @if(chatService.visible() && chatService.mode() === 'Sidebar') {
          <p-splitter>
            <ng-template #panel>
              <router-outlet></router-outlet>
            </ng-template>
            <ng-template #panel>
              <app-chat-dialog></app-chat-dialog>
            </ng-template>
          </p-splitter>
         } @else {
          <router-outlet></router-outlet>
         } -->
      </div>
    </div>
  </div>
  <!-- <app-config></app-config> -->
</div>
<!-- @if(chatService.visible() && chatService.mode() === 'Dialog') {
  <app-chat-dialog></app-chat-dialog>
} -->

<p-dialog
  [(visible)]="organizationDialogVisible"
  [modal]="true"
  [draggable]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [style]="{ width: '32rem', maxWidth: '92vw' }"
>
  <ng-template #header>
    <div class="text-lg font-semibold text-neutral-900 dark:text-neutral-100">Select Organization</div>
  </ng-template>

  <div class="flex flex-col gap-3">
    <div class="max-h-72 overflow-y-auto rounded-xl border border-neutral-200 dark:border-neutral-800 p-2">
      <div class="flex flex-col gap-1">
        @for (org of sessionService.organizationOptions(); track org.id) {
          <button
            type="button"
            (click)="onSelectOrganization(org)"
            class="flex w-full items-center gap-3 rounded-lg px-3 py-2 text-left hover:bg-neutral-100 dark:hover:bg-neutral-900"
          >
            <app-identicon [seed]="org.id" class="h-6 w-6 rounded-sm shrink-0" />
            <div class="min-w-0 flex-1">
              <div class="truncate text-sm font-medium text-neutral-900 dark:text-neutral-100">{{ org.name }}</div>
              <div class="text-xs text-neutral-500 dark:text-neutral-400">{{ org.role }}</div>
            </div>
            @if (sessionService.activeOrganizationId() === org.id) {
              <i class="pi pi-check text-emerald-500"></i>
            }
          </button>
        } @empty {
          <div class="rounded-lg bg-neutral-100 dark:bg-neutral-900 px-3 py-4 text-sm text-neutral-600 dark:text-neutral-300">
            No organizations available.
          </div>
        }
      </div>
    </div>

    <div class="flex items-center justify-between gap-2">
      <button
        type="button"
        (click)="onManageOrganizations()"
        class="text-sm text-brand-link hover:underline"
      >
        Manage organizations
      </button>
      <div class="flex items-center gap-2">
        @if (sessionService.activeOrganizationId()) {
          <p-button size="small" label="Settings" icon="pi pi-cog" [text]="true" (click)="onManageSelectedOrganization()" />
        }
        <p-button size="small" label="Create" icon="pi pi-plus" (click)="onCreateOrganization()" />
      </div>
    </div>
  </div>
</p-dialog>

<!-- Inbox Drawer -->
<app-inbox-drawer [(visible)]="inboxDrawerVisible"></app-inbox-drawer>

<app-create-org-dialog [(visible)]="createOrganizationDialogVisible"></app-create-org-dialog>

<!-- Create Account Dialog -->
<p-dialog
  [(visible)]="layoutService.createAccountDialogVisible"
  (onClose)="layoutService.createAccountDialogVisible.set(false)"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [dismissableMask]="true"
  [closeOnEscape]="true"
>
  <ng-template #header>
    <div class="text-lg font-bold pb-4">Create New Account</div>
  </ng-template>
  @if(createAccountSuccess()) {
    <div class="text-md max-w-[20rem]">
      Account created successfully
    </div>
  } @else {
    <div class="text-md max-w-[20rem]">
      Creating a new account will allow you to manage your team members, billing, and subscriptions separately.
    </div>
    <form [formGroup]="createAccountForm" class="flex flex-col gap-2 pt-4">
      <input pInputText formControlName="name" placeholder="Account Name" (keyup.enter)="createAccount()" />
      @if(createAccountForm.get('name')?.errors?.['required']) {
        <div class="text-sm text-red-500">
          Account Name is required
        </div>
      }
      <div class="flex flex-row items-center gap-2">
        <p-checkbox formControlName="is_default" [binary]="true"></p-checkbox>
        <label class="text-sm">Set as Default Account</label>
      </div>
    </form>
  }
  <ng-template #footer>
    @if(createAccountSuccess()) {
      <p-button class="w-full" styleClass="w-full" icon="pi pi-cog" size="small" severity="info" label="Manage Accounts" (click)="onManageAccounts()"></p-button>
    } @else {
      <div class="flex flex-row gap-4 items-center justify-center w-full">
        <p-button icon="pi pi-plus" size="small" [disabled]="createAccountForm.invalid || createAccountLoading()" size="small" severity="success" icon="pi pi-check" label="Create Account" (click)="createAccount()"></p-button>
        <p-button icon="pi pi-times" size="small" severity="secondary" label="Cancel" (click)="layoutService.createAccountDialogVisible.set(false)"></p-button>
      </div>
    }
  </ng-template>
</p-dialog>


<!-- Floating Support FAB (visible on all app pages) -->
<a
  routerLink="/app/support"
  title="Help & Support"
  aria-label="Help & Support"
  class="group fixed bottom-5 right-5 z-[900] flex items-center h-12 rounded-full bg-[#F97002] hover:bg-[#d45f00] active:bg-orange-700 text-white shadow-lg shadow-black/25 transition-all duration-300 pl-[15px] pr-[15px] hover:pr-5"
>
  <i class="pi pi-question-circle text-lg shrink-0"></i>
  <span class="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium opacity-0 transition-all duration-300 group-hover:max-w-[120px] group-hover:opacity-100 group-hover:ml-2">Support</span>
</a>
